export default {
  id: 'ImageCropper',
  code: 'CN',
  text: {
    'Proceed to cancel uploading image?': '确认取消上传图片？',
    'Cancel': '取消',
    'Upload': '上传',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/ImageCropper/locale.js